<template>
    <ul class="mkt-breadcrumbs">
        <li v-for="({label, url}, i) in breadcrumbs" :key="i" class="mkt-breadcrumb">
            <NuxtLink v-if="url && i !== breadcrumbs.length - 1" :to="url">{{ label }}</NuxtLink>
            <strong v-else>{{ label }}</strong>
        </li>
    </ul>
</template>

<script setup lang="ts">
    type Breadcrumb = {label: string; url?: string};
    defineProps<{breadcrumbs: Breadcrumb[]}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .mkt-breadcrumbs {
        display: flex;
        flex-wrap: wrap;
        column-gap: var(--joy-core-spacing-4);
        margin-bottom: var(--joy-core-spacing-6);
        font-size: var(--joy-font-size-primary-200);
        list-style-type: none;

        @include mq.screen_md(min) {
            margin-bottom: var(--joy-core-spacing-8);
            font-size: var(--joy-font-size-primary-400);
        }
    }

    .mkt-breadcrumb {
        white-space: nowrap;

        a,
        a:visited {
            user-select: none;
            color: inherit;
        }

        a:hover {
            text-decoration: underline;
        }

        span {
            cursor: default;
        }

        &:not(:first-child)::before {
            content: '/';
            position: relative;
            left: calc(-1 * var(--joy-core-spacing-2));
        }
    }
</style>
